<template>
  <div class="container-fluid">
    <div>
      <div class="card">
        <div class="card-header">
          <div class="row">
            <div class="col col-xs-2">
              <h4 class="panel-title">
                <span class="title">Gereciamento Fornecedor</span>
                <br/>
                <span class="navigation">Fornecedor > Cadastro</span>
              </h4>
            </div>
          </div>
        </div>
        <div class="card-body">
          <form name="form" @submit.prevent="onSubmit">
            <div>
              <template v-if="validation.hasError('fornecedor.nome')">
                <InlineMessage>{{ validation.firstError('fornecedor.nome') }}</InlineMessage>
              </template>

							<template v-if="validation.hasError('fornecedor.cnpj')">
                <InlineMessage>{{ validation.firstError('fornecedor.cnpj') }}</InlineMessage>
              </template>

							<template v-if="validation.hasError('fornecedor.endereco')">
                <InlineMessage>{{ validation.firstError('fornecedor.endereco') }}</InlineMessage>
              </template>
            </div>

						<div class="row">
						<div class="col-md-4 mb-2">
							<label for="contrib">Contribuinte: *</label>
							<span class="p-fluid">
								<AutoComplete
								id="contrib"
								:dropdown="true"
								v-model="currentUser.contribuinte.nome"
								placeholder="Pesquisar"
								disabled
								>
								</AutoComplete>
							</span>
						</div>
					</div>

						<div class="row">
							<div class="col-md-3 mb-2">
							<label for="cnpj">CNPJ: *</label>
								<span class="p-fluid">
								<InputMask
									mask="99.999.999/9999-99"
									autocomplete="off"
									placeholder="99.999.999/9999-99"
									id="cnpj"
									v-model="fornecedor.cnpj"
									:class="{
									'p-error': validation.hasError('fornecedor.cnpj')
									}"
								/>
								</span>
							</div>
						</div>

            <div class="row">
              <div class="col-md-4 mb-2">
                <label for="nome">Nome: *</label>
                <span class="p-fluid">
                  <InputText
                    type="text"
                    id="nome"
                    v-model="fornecedor.nome"
                    :class="{'p-error': validation.hasError('fornecedor.nome')}"
                  />
                </span>
              </div>
            </div>

						<div class="row">
              <div class="col-md-4 mb-2">
                <label for="endereco">Endereço: *</label>
                <span class="p-fluid">
                  <InputText
                    type="text"
                    id="endereco"
                    v-model="fornecedor.endereco"
                    :class="{'p-error': validation.hasError('fornecedor.endereco')}"
                  />
                </span>
              </div>
            </div>

            <hr />
            <template>
              <Button
                label="Gravar"
                title="Gravar"
                type="submit"
                class="p-button-primary mr-2 p-button-success"
                icon="pi pi-check"
                :disabled="loading"
              >
              </Button>
              <router-link to="/fornecedorConsulta">
                <Button
                  label="Voltar"
                  title="Voltar"
                  type="button"
                  class="p-button-primary mr-2"
                  icon="pi pi-arrow-left"
                  :disabled="loading"
                ></Button>
              </router-link>
            </template>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LoginService from "../services/acesso/login.service";
import fornecedorService from '../services/obras/fornecedor.service';
import Fornecedor from "../models/obras/Fornecedor";
import SimpleVueValidation from "simple-vue-validator";
const Validator = SimpleVueValidation.Validator;

export default {
	name: 'ContribFornecedorCadastro',
	data() {
		return{
			loading: false,
			fornecedor: new Fornecedor()
		}
	},
	
	created(){
		this.currentUser = LoginService.currentUserValue;
		this.id = this.$route.params.idFornecedor;

		if(this.id != null){
			setTimeout(async() => {
				await fornecedorService.getFornecedor(this.id).then(
					response=>{
						this.fornecedor = response.data;
					},
					error=>{
						let errorMessage = "Houve um problema ao buscar o Fornecedor!";
						if(error.response){
							errorMessage = error.response.data;
						}
						this.$toast.add({
							severity: "error",
							summary: errorMessage
						});
					}
				)
			},250);
		}
	},

	validators: {
		"fornecedor.nome": function(value){
			return Validator.value(value)
			.required("Nome Obrigatório")
			.maxLength(200, "Deve ser menor ou igual a 200")
		},
		"fornecedor.cnpj": function(value){
			return Validator.value(value)
			.required("CNPJ Obrigatório")
			.maxLength(200, "Deve ser menor ou igual a 20")
		},
		"fornecedor.endereco": function(value){
			return Validator.value(value)
			.required("Endereço Obrigatório")
			.maxLength(200, "Deve ser menor ou igual a 200")
		},
	},

	methods: {
		onSubmit(){
			this.loading = true;
			this.$validate().then((success) => {
				if (success) {
					this.salvar();
				}
			});
			this.loading = false;
		},

		salvar(){
			this.fornecedor.idCliente = this.currentUser.usuario.idCliente;
			this.fornecedor.idContribuinteCadastro = this.currentUser.contribuinte.idContribuinte;

			fornecedorService.saveFornecedor(this.fornecedor).then(
				data => {
					console.log(data);
					this.$toast.add({
						severity: "success",
						summary: "Fornecedor salvo com sucesso!"
					});
					this.$router.push("fornecedorConsulta");
					console.log(data);
				},
				error => {
					let errorMessage = "Houve um erro ao salvar o Fornecedor!";
					if(error.response){
						errorMessage = error.response.data;
					}
					this.$toast.add({
						severity: "error",
						summary: errorMessage
					});
				}
			);
		},

		limparForm(){
			this.fornecedor.nome = '';
			this.fornecedor.cnpj = '';
			this.fornecedor.endereco = '';
		},

		processando(show) {
			if (show) {
				this.loading = true;
				this.$root.$emit("loading:show");
			} else {
				this.loading = false;
				this.$root.$emit("loading:hide");
			}
		}
	}
}
</script>